import React, { useEffect, useRef, useState } from "react";
import setInputValues from "../../utils/helpers/setInputValue";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  postDetails,
  postMultipartDetails,
} from "../../services/http/http.service";
import APIList from "../../utils/constants/APIList";
import LayoutContainer from "../../components/Containers/LayoutContainer";
import "@fortawesome/fontawesome-free/css/all.min.css";
import InputField from "../../components/InputField/InputField";
import CustomDatePicker from "../../components/CustomDatePicker/CustomDatePicker";
import CustomButton from "../../components/CustomButton/CustomButton";
import CustomDropdown from "../../components/CustomDropdown/CustomDropdown";
import PageHeader from "../../components/PageHeader/PageHeader";
import { PlusCircleFill, ArrowLeft } from "react-bootstrap-icons";
import CommonTable, { TableColumn } from "../../components/Table/CommonTable";
import { useAppDispatch } from "../../store/storeRequests";
import { hideLoader, showLoader } from "../../store/Loader/loader.slice";
import { ModalRef } from "../../utils/constants/Interfaces.constants";
import ModalWrapper from "../../components/Modal/ModalWrapper";
import { hideToast, showToast } from "../../store/Toast/toast.slice";
import convertTimestamp from "../../utils/helpers/convertTimeStamp";

interface QuizData {
  id: number;
  created: Date;
  folder_id: number;
  question: string;
  quizType: string;
  correct_answer: string;
  correctAnswerCount: number;
  wrongAnswerCount: number;
  status: number;
}

interface QuizItem {
  id: number;
  folder_name: string;
  quizData: QuizData[];
}

const TrainingQuizDetails = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const cmpMounted = useRef(false);
  const [quizItems, setQuizItems] = useState<any>([]);
  const [folderName, setFolderName] = useState<string>("");
  const dispatch = useAppDispatch();
  const userModalRef = useRef<ModalRef>(null);
  const [submittedUsers, setSubmittedUsers] = useState<any>(null);
  const [correctSubmissions, setCorrectSubmissions] = useState<any>([]);
  const [wrongSubmissions, setWrongSubmissions] = useState<any>([]);

  useEffect(() => {
    if (cmpMounted.current === true) return;
    if (id) {
      fetchQuizDetails();
      cmpMounted.current = true;
    }
  }, [id]);

  const fetchQuizDetails = async () => {
    try {
      dispatch(showLoader("Loading data..."));
      const response = await postDetails(
        APIList.GET_TRAINING_QUIZ_FOLDER_BY_ID,
        { folder_id: Number(id) }
      );
      console.log(response);
      setFolderName(response.data.folder_name);
      if (response.data.quizData) {
        const result = response.data.quizData.map((quiz: QuizData) => ({
          folder_name: response.data.folder_name,
          ...quiz,
          created: convertTimestamp(quiz.created),
        }));
        setQuizItems(result);
      } else {
        setQuizItems([]);
      }

      // console.log(result)
    } catch (error) {
      console.log(error);
    } finally {
      dispatch(hideLoader());
    }
  };

  const filterUsers = (usersData: any, correct_answer: string) => {
    const correct: any = [];
    const wrong:any = [];
   console.log(correct_answer)
    usersData.userInfo.forEach((user:any) => {
      if (user.submittedOption === correct_answer) {
        correct.push(user);
      } else {
        wrong.push(user);
      }
    });

    setCorrectSubmissions(correct);
    setWrongSubmissions(wrong);
  };

  const getUsersSubmitted = async (item: any) => {
    console.log(id);
    try {
      const response = await postDetails(APIList.GET_SUBMITTED_USERS, {
        quiz_id: item.id,
      });
      console.log(response);
      filterUsers(response.data, item.correct_answer);
      // setSubmittedUsers(response.data);
    } catch (error) {
      console.log("Unable to get submitted users", error);
    }
  };

  const columns: TableColumn[] = [
    { key: "created", label: "Created", sortable: true, dataType:"string" },
    { key: "folder_name", label: "Folder Name", sortable: true , dataType:"string"},
    { key: "question", label: "Question", sortable: true, dataType:"string" },
    { key: "quiz_type", label: "Quiz Type", sortable: true , dataType:"string"},
    { key: "correct_answer", label: "Quiz Correct Answer", render: (item)=>{
      if(item.quiz_type === "Image Option"){
        return (
          <img src={item.correct_answer} alt="Correct Answer" width={50}  />
        )
      } else {
        return item.correct_answer
      }
    } },
    // { key: "descriptive", label: "Descriptive" , sortable: true},
    {
      key: "correctAnswerCount",
      label: "Quiz Correct Answer User",
      render: (item) => {
        return (
          <div
            className="text-primary cursor-pointer text-decoration-underline"
            onClick={() => getUsersSubmitted(item)}
          >
            {" "}
            {item.correctAnswerCount || 0}{" "}
          </div>
        );
      },
    },
    {
      key: "wrongAnswerCount",
      label: "Quiz Wrong Answer User",
      render: (item) => {
        return (
          <div
            className="text-primary cursor-pointer text-decoration-underline"
            onClick={() => getUsersSubmitted(item)}
          >
            {" "}
            {item.wrongAnswerCount || 0}{" "}
          </div>
        );
      },
    },
  ];

  const redirectToQuizFolder = () => {
    navigate("/training-quiz");
  };

  const handleAddQuiz = () => {
    navigate("/training-quiz/addQuiz");
  };

  const buttons = [
    {
      label: "Back to Main List",
      theme: "danger",
      icon: <ArrowLeft />,
      onClick: redirectToQuizFolder,
    },
  ];

  const deleteQuiz = async (item: any) => {
    try {
      const response = await postDetails(APIList.DELETE_TRAINING_QUIZ, {
        id: item.id,
      });
      console.log(response);

      if(response.status === "Failed"){
        alert("Cannot delete Quiz")
        return
      }

      dispatch(showToast("Quiz Deleted Successfully"));
      setTimeout(() => dispatch(hideToast()), 3000);

      fetchQuizDetails()

    } catch (error) {
      console.log(error);
    }
  };

  const toggleQuizStatus = async (item: any) => {
    try {
      const response = await postDetails(APIList.TOGGLE_TRAINING_QUIZ_STATUS, {
        id: item.id,
        status: item.status === 0 ? 1 : 0,
      });
      console.log(response);

      if(response.status === "Failed"){
        alert("Cannot change Quiz status")
        return
      }

      dispatch(showToast("Quiz Status Changed Successfully"));
      setTimeout(() => dispatch(hideToast()), 3000);

      setQuizItems((prevData: any) =>
        prevData.map((row: any) =>
          row.id === item.id
            ? { ...row, status: row.status === 0 ? 1 : 0 }
            : row
        )
      );

      fetchQuizDetails()
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <LayoutContainer title="TrainingQuiz">
      <ModalWrapper
        ref={userModalRef}
        title={submittedUsers?.question && submittedUsers.question}
      ></ModalWrapper>
      <div className=" page-header d-flex align-items-center justify-content-left dashboard-container h-100 mb-4">
        <h2>
          <i className="page-header-icon fa fa-home"></i>
          Training Quiz {folderName && `- ${folderName}`}
        </h2>
        <PageHeader buttons={buttons} />
      </div>
      <div className="mx-2">
        {quizItems.length !== 0 ? (
          <CommonTable<QuizData>
            data={quizItems}
            columns={columns}
            onDelete={deleteQuiz}
            onStatusToggle={toggleQuizStatus}
            pagination={true}
            rowsPerPage={10}
            actions={{
              view: false,
              edit: false,
              delete: true,
              checkbox: false,
              status: true,
              showModal: false,
            }}
          />
        ) : (
          <p>No Quiz Posted</p>
        )}
      </div>
    </LayoutContainer>
  );
};

export default TrainingQuizDetails;
